import {
  AttendContactAbsenceEntity,
} from './attendContactAbsenceEntity';
import { AbsenceDate } from './valueObjects/absenceDate';
import { AbsenceReason } from './valueObjects/absenceReason';
import { AbsenceReasonDetailInfection } from './valueObjects/absenceReasonDetailInfection';
import { AbsenceReasonDetailSick } from './valueObjects/absenceReasonDetailSick';
import { ChildId } from './valueObjects/childId';
import { Memo } from './valueObjects/memo';
import { NurseryId } from './valueObjects/nurseryId';
import { ParentId } from './valueObjects/parentId';

import type {
  AttendContactAbsencePropsPub,
  AttendContactAbsencePropsPvt,
} from './attendContactAbsenceEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { AttendContactAbsenceJsonPub, AttendContactAbsenceJsonPvt } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class AttendContactAbsenceFactory extends FactoryPub<
  AttendContactAbsenceEntity,
  AttendContactAbsencePropsPvt,
  AttendContactAbsenceJsonPvt,
  AttendContactAbsencePropsPub,
  AttendContactAbsenceJsonPub
> {
  comparePub = (
    a: EntityDataPubType<AttendContactAbsenceJsonPvt, AttendContactAbsenceJsonPub>,
    b: EntityDataPubType<AttendContactAbsenceJsonPvt, AttendContactAbsenceJsonPub>,
  ) => {
    const da = new Date(a.data.absenceDate);
    const db = new Date(b.data.absenceDate);
    return da < db ? 1 : -1;
  };

  create(
    props: AttendContactAbsencePropsPvt,
    propsPub: EntityPubNotNullType<AttendContactAbsencePropsPub>,
  ): AttendContactAbsenceEntity {
    return new AttendContactAbsenceEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<AttendContactAbsenceJsonPvt, AttendContactAbsenceJsonPub>,
  ): AttendContactAbsenceEntity {
    return this.create({
      nurseryId: NurseryId.create(props.data.nurseryId),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      absenceDate: AbsenceDate.create(new Date(props.data.absenceDate)),
      absenceReason: AbsenceReason.create(props.data.absenceReason),
      absenceReasonDetailInfection:
        props.data.absenceReasonDetailInfection
          ? AbsenceReasonDetailInfection.create(props.data.absenceReasonDetailInfection)
          : undefined,
      absenceReasonDetailSick:
        props.data.absenceReasonDetailSick
          ? AbsenceReasonDetailSick.create(props.data.absenceReasonDetailSick)
          : undefined,
      memo: Memo.create(props.data.memo),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
